<script lang="ts">
  import { fade } from "svelte/transition";
  import BlockEditor from "./BlockEditor.svelte";
  import type { schema } from "@editor/schema";
  import TextField from "./form/TextField.svelte";
  import RichTextField from "./form/RichTextField.svelte";
  import DateTimeTZField from "./form/DateTimeTZField.svelte";
  import LocationField from "./form/LocationField.svelte";
  import CollapsibleSection from "@ui/CollapsibleSection.svelte";

  import GoogleMap from "./utils/GoogleMap.svelte";
  import cloneDeep from "lodash.clonedeep";

  export let block: schema.EventBlock;
  let draft: schema.EventBlock = cloneDeep(block);
  export let focusField: string = "name";
</script>

<BlockEditor {draft} on:done on:cancel>
  <div class="flex justify-between">
    <div class="flex-grow">
      <TextField label="Name" limit={100} autofocus required bind:value={draft.name} placeholder="Enter your event name" />
    </div>
    <div class="flex w-48 ml-3">
      <DateTimeTZField label="When?" required bind:value={draft.date} />
    </div>
  </div>

  <div class="flex mt-2">
    <div class="flex-grow">
      <LocationField label="Where?" placeholder="Enter event's location" bind:value={draft.location} />

      <label class="flex items-center mt-2 ml-1 text-gray-600 cursor-pointer text-12">
        <input type="checkbox" bind:checked={draft.hideMapFromEvent} class="mr-2" />
        Don't show map
      </label>

      <label class="flex items-center mt-2 ml-1 text-gray-600 cursor-pointer text-12">
        <input type="checkbox" bind:checked={draft.collectRSVP} class="mr-2" />
        Collect RSVPs to this event
      </label>
    </div>
    {#if !draft.hideMapFromEvent}
      <div
        class="relative w-48 ml-3 overflow-hidden text-sm font-normal border rounded shadow-inner text-brand-gray-70"
        style="height:84px;margin-top:22px">
        <GoogleMap address={draft.location} />
      </div>
    {/if}
  </div>

  <!-- <div class="flex items-center">
    
    <span class="mx-3 mt-2 text-gray-600 text-10">OR</span>
    <CollapsibleSection title="Add conferencing link" captionClasses="mt-2" icon="video_call" isOpen={false} autofocus />
  </div> -->

  <CollapsibleSection title="Add event agenda & details" captionClasses="mt-2" icon="info" startOpen={!!block.details} autofocus>
    <div class="mt-3">
      <RichTextField label="Details" bind:value={draft.details} />
    </div>
  </CollapsibleSection>

  <!-- <div class="mt-4">
    <div class="flex items-start justify-between">
      <div>
        <LocationField key="location" name="Where?" disabled={(rawData || block)?.onlineEvent} placeholder="Enter Event's Location" />

        <div class="flex flex-col items-start justify-start mt-4">
          <CheckboxField key="onlineEvent" name="This is an online event and has no physical location" />
          <div class="mt-1" class:opacity-0={(rawData || block)?.onlineEvent} class:hidden={(rawData || block)?.onlineEvent}>
            <CheckboxField
              key="hideMapFromEvent"
              name="Hide map from event"
              disabled={(rawData || block)?.onlineEvent ? true : undefined} />
          </div>
        </div>
      </div>

      <div>
        {#if !(rawData || block).hideMapFromEvent && !(rawData || block).onlineEvent}
          <div
            class="relative flex items-center justify-center w-40 mt-6 overflow-hidden text-sm font-normal border rounded shadow-inner text-brand-gray-70"
            style="height:100px;">
            <GoogleMap address={(rawData || block).location} />
            No Preview
          </div>
        {/if}
      </div>
    </div> -->

  <!-- </div> -->
</BlockEditor>
